<template>
  <div class="cross_sale_container container my-2">

    <div class="row custom_padding_row custom_margin_row">
      <!-- Only show cross-sell UI if crossSaleAdded is false -->
      <div class="col-12 col-lg-9 col-md-9 mx-auto custom_padding_col custom_margin_col" v-if="crossSale.length > 0 && !props.crossSaleAdded">
        <CrossSale :sale="crossSale[0]" :orderID="orderID" :productID="productID" @remove="removeOrder" />
      </div>
    </div>


  </div>
</template>

<script setup lang="ts">
import crossSaleService from "@/services/crossSale";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import CrossSale from "./crossSale.vue";
const router = useRouter();

// ========================= initialize data =========================
const crossSale = ref([]);
const props = withDefaults(defineProps<{
  orderID?: any;
  productID?: any;
  crossSaleAdded?: string | boolean;
}>(), {
  orderID: '',
  productID: '',
  crossSaleAdded: false
});

const isLoading = ref(true);

// =========================== Methods =====================
const getCrossSaleAfterOrder = () => {
  isLoading.value = true;

  // If crossSaleAdded is true, request total order price for pixel tracking
  const useTotalOrderPrice = !!props.crossSaleAdded;

  crossSaleService.getCrossSaleAfterOrder(props.orderID, props.productID, useTotalOrderPrice)
    .then((res: any) => {
      isLoading.value = false;
      let response = res.data.data;

      // Handle cross-sells
      const crossSells = response.cross_sells || response;
      const currentPath = router.currentRoute.value.path;
      const isThankYouPage = currentPath === '/pages/thank';
      const isConfirmationPage = currentPath === '/pages/confirmation';

      if (crossSells.length > 0 && isThankYouPage && !crossSells[0].display_locations.includes('thank_you_page')) {
        crossSale.value = [];
        return;
      }

      if(crossSells.length == 0) {
        crossSale.value = [];
      } else {
        crossSale.value = crossSells;

        // Fire ViewCrossSell event only when cross-sells are displayed on thank you or confirmation page
        if (response.pixel_tracking && (isThankYouPage || isConfirmationPage)) {
          console.log('Firing pixel tracking for cross-sell view');
          fireViewCrossSellEvent(response.pixel_tracking);
        }
      }

    })
    .catch((err: any) => {
      isLoading.value = false;
    });
};

const fireViewCrossSellEvent = (pixelData: any) => {
  const pixelTrackingData = {
    ...pixelData,
    page_url: window.location.href
  };

  console.log('Firing ViewCrossSell event with data:', pixelTrackingData);

  // Facebook Pixel - ViewCrossSell custom event
  if (typeof (window as any).fbq !== 'undefined') {
    try {
      (window as any).fbq('trackCustom', 'ViewCrossSell', pixelTrackingData);
      console.log('Facebook ViewCrossSell event fired');
    } catch (error) {
      console.error('Error firing Facebook ViewCrossSell event:', error);
    }
  }

  // TikTok Pixel - ViewCrossSell custom event
  if (typeof (window as any).ttq !== 'undefined') {
    try {
      const tiktokPixelData = { ...pixelTrackingData };
      if (tiktokPixelData.content_type && tiktokPixelData.content_type !== 'product') {
        tiktokPixelData.content_type = 'product_group';
      }
      (window as any).ttq.track('ViewCrossSell', tiktokPixelData);
      console.log('TikTok ViewCrossSell event fired');
    } catch (error) {
      console.error('Error firing TikTok ViewCrossSell event:', error);
    }
  }
};

const removeOrder = () => {
  crossSale.value = [];

  if (router.currentRoute.value.path === '/pages/confirmation') {  
    const currentQuery = { ...router.currentRoute.value.query };
    router.push({
      path: '/pages/thank',
      query: currentQuery
    });
  }

};
// ========================= onMounted ===================
onMounted(() => {
  getCrossSaleAfterOrder();
});

</script>

<style lang="scss" scoped>
.cross_sale_container {
  .skeleton-item {
  background-color: #dadce3;
  border-radius: 12px;
  .img-skeleton {
    width: 100%;
    height: 260px;
}

}


  @media (min-width: 320px) and (max-width: 374.98px) {
    .custom_padding_row {
      padding-left: 0px;
      padding-right: 0px;

      .custom_padding_col {
         padding: inherit!important;
      }
    }

    .custom_margin_row{
      .custom_margin_col{

      }
    }
  }


  @media (min-width: 375px) and (max-width: 424.98px) {
    .custom_padding_row {
      padding-left: 0px;
      padding-right: 0px;

      .custom_padding_col {
        padding: inherit!important;
      }
    }

    .custom_margin_row{
      .custom_margin_col{

      }
    }
  }



  @media (min-width: 425px) and (max-width: 575.98px) {
    .custom_padding_row {
      padding-left: 0px;
      padding-right: 0px;

      .custom_padding_col {
        padding: inherit!important;
      }
    }
  }

  /* ========== Small Tablets ========== */
  /* مثل Galaxy Tab أو موبايل أفقي */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .custom_padding_row {
      padding-left: 0px;
      padding-right: 0px;

      .custom_padding_col {
        padding: inherit!important;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    .custom_padding_row {
      padding-left: 0px;
      padding-right: 0px;

      .custom_padding_col {
        padding: inherit!important;
      }
    }
  }

}

</style>
